import script from "./RankSkills.vue?vue&type=script&setup=true&lang=js"
export * from "./RankSkills.vue?vue&type=script&setup=true&lang=js"

import "./RankSkills.vue?vue&type=style&index=0&id=2da5e0d9&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2da5e0d9"]])

export default __exports__